import { AuthProvider } from '../features/auth';
import { AppRouter } from './AppRouter';
import { usePathname } from './navigation';
import { parseAppRoute } from './routes';
import { RouteLoading } from './RouteLoading';

/** Authentication gates editing/admin routes, while the viewer has an anonymous session. */
export function AppRoot() {
  const route = parseAppRoute(usePathname());
  return (
    <AuthProvider
      loadingFallback={<RouteLoading route={route} />}
      requireLogin={
        route.area !== 'ifc-viewer' &&
        route.area !== 'map' &&
        route.area !== 'document-preview' &&
        route.area !== 'dashboard'
      }
    >
      <AppRouter route={route} />
    </AuthProvider>
  );
}
